import { useState } from "react";
import { ChevronDown, Info } from "lucide-react";
import { LABOR_DEPRECIATION_PROHIBITED_STATES } from "../utils/laborDepreciationStates";
import { cn } from "@/lib/utils";

export default function LaborDepreciationCallout() {
  const [open, setOpen] = useState(false);
  return (
    <div className="rounded-2xl border border-border bg-card overflow-hidden">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between p-5 text-left hover:bg-muted/30 transition-colors"
        aria-expanded={open}
      >
        <div className="flex items-start gap-3">
          <Info className="h-4 w-4 text-primary mt-0.5 shrink-0" />
          <div>
            <div className="text-sm font-semibold">The labor depreciation trick — and where it's banned</div>
            <div className="text-xs text-muted-foreground mt-0.5 max-w-prose">
              Some insurers depreciate labor (not just materials) on roof and structural claims.
              15 states explicitly prohibit it.
            </div>
          </div>
        </div>
        <ChevronDown className={cn("h-4 w-4 text-muted-foreground transition-transform", open && "rotate-180")} />
      </button>
      {open && (
        <div className="px-5 pb-5 animate-fade-in">
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-2">
            {LABOR_DEPRECIATION_PROHIBITED_STATES.map((s) => (
              <div
                key={s.code}
                className="rounded-lg border border-emerald-200 bg-emerald-50/60 px-3 py-2 text-xs"
              >
                <span className="font-mono font-semibold text-emerald-700 mr-1.5">{s.code}</span>
                <span className="text-emerald-900/80">{s.name}</span>
              </div>
            ))}
          </div>
          <p className="text-xs text-muted-foreground mt-4 leading-relaxed">
            If your insurer is depreciating labor on your claim and you live in one of these states, that's not a gray
            area — it's prohibited. Push back, in writing.{" "}
            <a href="/blog/acv-vs-rcv-insurance" className="text-primary underline-offset-2 hover:underline">
              Read the full guide →
            </a>
          </p>
        </div>
      )}
    </div>
  );
}
